/* MONK 81673 retired by Juan 5 Oct 2026. Remove only its stale marked ORE gift; never add products or alter paid ORE. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.VNGiftGuard = api.install(root);
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  const ORE = '56410464452982';
  const NAD = '58282252435830';
  const MOR = '55612287943030';
  const GIFT_TITLE = 'Oregano de regalo con tu pack';
  const MESSAGE = 'No hemos podido actualizar el carrito. Revísalo y vuelve a intentar continuar al pago.';
  const isGift = (item) => String(item.variant_id || item.id) === ORE && String((item.properties || {})._mr) === '1';
  const quantityOf = (cart, id) => cart.items.reduce((sum, item) => sum + (String(item.variant_id || item.id) === id ? item.quantity : 0), 0);
  const eligible = () => false; // Offer retired; stale auto-added lines must not become paid items.

  function giftPricingIsSafe(cart) {
    if (!cart.items.some(isGift)) return true;
    if (!eligible(cart)) return false;
    let freeUnits = 0;
    // MONK may discount the paid ORE line instead of its marked auto-added line.
    // Validate the native 100% allocation across this variant; never move properties or prices.
    for (const item of cart.items.filter((entry) => String(entry.variant_id || entry.id) === ORE)) {
      const { original_price: unit, original_line_price: original, final_line_price: final, discounts, line_level_discount_allocations: allocations } = item;
      if (!Number.isInteger(unit) || unit <= 0 || original !== unit * item.quantity ||
          !Number.isInteger(final) || final < 0 || final > original ||
          !Array.isArray(discounts) || !Array.isArray(allocations)) return false;
      const listed = new Map();
      const allocated = new Map();
      let total = 0;
      for (const discount of discounts) {
        if (typeof discount.title !== 'string' || !Number.isInteger(discount.amount) || discount.amount < 0) return false;
        listed.set(discount.title, (listed.get(discount.title) || 0) + discount.amount);
        total += discount.amount;
      }
      for (const allocation of allocations) {
        const rule = allocation.discount_application;
        if (!rule || typeof rule.title !== 'string' || !Number.isInteger(allocation.amount) || allocation.amount < 0) return false;
        allocated.set(rule.title, (allocated.get(rule.title) || 0) + allocation.amount);
        if (rule.title === GIFT_TITLE) {
          if (rule.value_type !== 'percentage' || Number(rule.value) !== 100 ||
              rule.target_type !== 'line_item' || allocation.amount !== unit) return false;
          freeUnits += 1;
        }
      }
      if (original - total !== final || listed.size !== allocated.size ||
          Array.from(listed).some(([title, amount]) => allocated.get(title) !== amount)) return false;
    }
    return freeUnits === 1;
  }

  function adjustments(cart) {
    let remaining = eligible(cart) ? 1 : 0;
    return cart.items.filter(isGift).flatMap((item) => {
      const quantity = Math.min(item.quantity, remaining);
      remaining -= quantity;
      return quantity === item.quantity ? [] : [{ id: item.key, quantity }];
    });
  }

  function checkedCart(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.errors) throw new Error(MESSAGE);
    if (cart.items.some((item) => !item.key || !Number.isInteger(item.quantity) || item.quantity < 0)) throw new Error(MESSAGE);
    return cart;
  }

  function createController(io) {
    let tail = Promise.resolve();
    let pending = 0;
    function enqueue(task) {
      pending += 1;
      if (io.busy) io.busy(true);
      const result = tail.catch(() => {}).then(task);
      tail = result.catch(() => {});
      return result.finally(() => { pending -= 1; if (io.busy) io.busy(pending > 0); });
    }
    async function reconcile(cart, checkout) {
      let changed = false;
      // Re-read after each key-based correction. A disappearing/changing key is never retried blindly.
      for (let attempt = 0; attempt < 4; attempt += 1) {
        const next = adjustments(cart)[0];
        if (!next) {
          if (checkout && !giftPricingIsSafe(cart)) throw new Error(MESSAGE);
          return { cart, changed };
        }
        await io.change(next);
        changed = true;
        cart = checkedCart(await io.read());
      }
      throw new Error(MESSAGE);
    }
    async function finish(result, render) {
      if (io.observe) io.observe(result.cart);
      if (render && io.render) await io.render(result.cart);
      return result;
    }
    return {
      get pending() { return pending; },
      ensure: (checkout, render = true) => enqueue(async () => finish(await reconcile(checkedCart(await io.read()), checkout), render)),
      changeQuantity: (key, quantity, sections, sectionsUrl) => enqueue(async () => {
        const current = checkedCart(await io.read());
        const item = current.items.find((entry) => entry.key === key);
        // An app may have changed a discount and therefore the key. Refresh instead of changing another line.
        if (!item) { await finish({ cart: current, changed: false }, true); throw new Error(MESSAGE); }
        if (!Number.isInteger(quantity) || quantity < 0) throw new Error(MESSAGE);
        if (isGift(item)) quantity = eligible(current) ? Math.min(quantity, 1) : 0;
        await io.change({ id: item.key, quantity });
        const result = await reconcile(checkedCart(await io.read()), false);
        if (io.observe) io.observe(result.cart);
        const html = await io.sections(sections, sectionsUrl);
        return { ...result.cart, sections: html };
      }),
    };
  }

  async function sectionsWithRetry(read, wait) {
    for (let attempt = 0; attempt < 3; attempt += 1) {
      try { return await read(); }
      catch (error) {
        const transient = [500, 502, 503, 504].includes(error.httpStatus) ||
          error.name === 'AbortError' || error.name === 'TypeError';
        if (!transient || attempt === 2) {
          // A failed GET must never replay the already-completed cart mutation.
          error.cartRenderFailed = true;
          throw error;
        }
        await wait(attempt === 0 ? 150 : 450);
      }
    }
  }

  function install(win) {
    const doc = win.document;
    const html = doc.documentElement;
    const cartUrl = () => (win.routes && win.routes.cart_url) || '/cart';
    let lastQuantityChange = 0;
    let refreshTimer;
    let checkoutPending = false;
    let bypassForm = null;
    const sleep = (ms) => new Promise((resolve) => win.setTimeout(resolve, ms));

    async function json(url, options) {
      const abort = new win.AbortController();
      const timeout = win.setTimeout(() => abort.abort(), 15000);
      try {
        const response = await win.fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: abort.signal, ...options });
        if (!response.ok) {
          const error = new Error(MESSAGE);
          error.httpStatus = response.status;
          throw error;
        }
        const data = await response.json();
        if (data.errors || data.status >= 400) throw new Error(MESSAGE);
        return data;
      } finally { win.clearTimeout(timeout); }
    }
    const sections = (ids, path) => sectionsWithRetry(
      () => json(`${path || cartUrl()}?sections=${encodeURIComponent(ids.join(','))}`),
      sleep
    );
    const signature = (cart) => cart.items.map((item) => `${item.key}|${item.quantity}|${item.final_line_price}`).join('\n');
    function domSignature(container) {
      return Array.from(container.querySelectorAll('[data-vn-cart-state]')).map((row) => row.dataset.vnCartState).join('\n');
    }
    function showError(message) {
      let node = doc.getElementById('cart-errors') || doc.getElementById('CartDrawer-CartErrors') || doc.getElementById('vn-gift-guard-message');
      if (!node) {
        node = doc.createElement('p'); node.id = 'vn-gift-guard-message';
        node.style.cssText = 'position:fixed;bottom:12px;left:12px;right:12px;padding:16px;background:white;color:#222;border:1px solid #aaa;z-index:10000';
        doc.body.appendChild(node);
      }
      node.setAttribute('role', 'alert'); node.textContent = message;
    }
    function specs() {
      const items = doc.getElementById('main-cart-items');
      const footer = doc.getElementById('main-cart-footer');
      const result = [];
      if (items && items.dataset.id) result.push({ id: items.id, section: items.dataset.id, selector: '.js-contents' });
      if (footer && footer.dataset.id) result.push({ id: footer.id, section: footer.dataset.id, selector: '.js-contents' });
      if (doc.getElementById('CartDrawer')) result.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
      if (doc.getElementById('cart-icon-bubble')) result.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
      return result;
    }
    async function render(cart) {
      const containers = Array.from(doc.querySelectorAll('cart-items, cart-drawer-items'));
      if (!containers.length || containers.every((node) => domSignature(node) === signature(cart))) return;
      const targets = specs();
      const sectionHtml = await sections(targets.map((entry) => entry.section), cartUrl());
      // Validate the complete response before replacing any products or totals.
      const replacements = targets.map((entry) => {
        const target = doc.getElementById(entry.id);
        const source = new win.DOMParser().parseFromString(sectionHtml[entry.section] || '', 'text/html').querySelector(entry.selector);
        if (!source) throw new Error(MESSAGE);
        return { target: target.querySelector(entry.selector) || target, source };
      });
      replacements.forEach(({ target, source }) => { target.innerHTML = source.innerHTML; });
      doc.querySelectorAll('cart-items, cart-drawer, #main-cart-footer').forEach((node) => node.classList.toggle('is-empty', cart.item_count === 0));
    }
    const controller = createController({
      read: () => json(`${cartUrl()}.js`),
      change: (payload) => {
        const route = (win.routes && win.routes.cart_change_url) || '/cart/change';
        return json(route.endsWith('.js') ? route : `${route}.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload),
        });
      },
      sections, render,
      observe: (cart) => {
        html.toggleAttribute('data-vn-gift-present', cart.items.some(isGift));
        html.removeAttribute('data-vn-gift-unknown');
      },
      busy: (value) => html.toggleAttribute('data-vn-gift-busy', value),
    });

    async function waitForQuantityChanges() {
      // Dawn debounces input changes by 300 ms; do not submit an old quantity meanwhile.
      const delay = typeof ON_CHANGE_DEBOUNCE_TIMER === 'number' ? ON_CHANGE_DEBOUNCE_TIMER + 100 : 400;
      while (Date.now() - lastQuantityChange < delay) await sleep(delay);
    }
    function scheduleRefresh(delay = 180) {
      win.clearTimeout(refreshTimer);
      refreshTimer = win.setTimeout(async () => {
        if (checkoutPending) return;
        try { await waitForQuantityChanges(); await controller.ensure(false); }
        catch (error) { if (html.hasAttribute('data-vn-gift-present')) showError(MESSAGE); }
      }, delay);
    }
    async function checkout(resume) {
      if (checkoutPending) return;
      checkoutPending = true;
      html.setAttribute('data-vn-checkout-busy', '');
      try {
        await waitForQuantityChanges();
        const result = await controller.ensure(true);
        if (result.changed) {
          showError('La promoción de regalo ha terminado y hemos retirado el artículo gratuito. Revisa el total y continúa al pago.');
          if (!doc.querySelector('cart-items, cart-drawer-items')) win.location.assign(cartUrl());
        } else resume();
      } catch (error) { showError(MESSAGE); }
      finally { checkoutPending = false; html.removeAttribute('data-vn-checkout-busy'); }
    }
    function submit(form, button) {
      form = form.isConnected ? form : doc.getElementById(form.id);
      if (!form) throw new Error(MESSAGE);
      bypassForm = form;
      try {
        if (button && button.isConnected && button.form === form) form.requestSubmit(button);
        else {
          const checkoutInput = doc.createElement('input');
          checkoutInput.type = 'hidden'; checkoutInput.name = 'checkout'; checkoutInput.value = 'checkout';
          form.appendChild(checkoutInput); form.requestSubmit(); checkoutInput.remove();
        }
      } finally { bypassForm = null; }
    }
    doc.addEventListener('change', (event) => {
      if (event.target.matches('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]')) lastQuantityChange = Date.now();
    }, true);
    doc.addEventListener('click', (event) => {
      const control = event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"], a[href]');
      if (!control) return;
      if (control.tagName === 'A') {
        const url = new win.URL(control.href, win.location.href);
        if (url.origin !== win.location.origin || !/(^|\/)checkout(?:\/|$)/.test(url.pathname)) return;
        event.preventDefault(); event.stopImmediatePropagation();
        checkout(() => win.location.assign(url.href));
      } else if (control.form) {
        event.preventDefault(); event.stopImmediatePropagation();
        const form = control.form;
        checkout(() => submit(form, control));
      }
    }, true);
    doc.addEventListener('submit', (event) => {
      if (event.target === bypassForm || !['cart', 'CartDrawer-Form'].includes(event.target.id)) return;
      if (event.submitter && event.submitter.name !== 'checkout') return;
      event.preventDefault(); event.stopImmediatePropagation();
      const form = event.target;
      checkout(() => submit(form, event.submitter));
    }, true);

    // Observe completed cart mutations made by apps without replacing fetch/XHR or adding products.
    if (win.PerformanceObserver) {
      try {
        new win.PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            const url = new win.URL(entry.name, win.location.href);
            if (url.origin === win.location.origin && /\/cart\/(add|change|update|clear)(?:\.js)?$/.test(url.pathname)) scheduleRefresh();
          }
        }).observe({ type: 'resource', buffered: true });
      } catch (error) { /* Initial and checkout validation still run in older browsers. */ }
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => { if (event.source !== 'cart-items') scheduleRefresh(); });
    }
    scheduleRefresh(0);
    // A bounded follow-up also covers a delayed native gift insertion on page arrival.
    win.setTimeout(() => scheduleRefresh(), 1200);
    win.addEventListener('pageshow', (event) => { if (event.persisted) scheduleRefresh(); });
    return controller;
  }
  return { isGift, eligible, adjustments, giftPricingIsSafe, createController, sectionsWithRetry, install };
});
